import React, { useState, useRef, useEffect } from 'react';
import { FiDownload, FiChevronDown } from 'react-icons/fi';
import { downloadAgent as downloadAgentAPI } from '../../../api/device';
import './WebAppAgentDownload.scss';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from 'react-i18next';

const OS_LIST = [
  { key: 'windows', label: 'Windows' },
  { key: 'linux-deb', label: 'Linux (.deb)' },
  { key: 'linux-arch', label: 'Linux (Arch)' },
  { key: 'linux-rpm', label: 'Linux (.rpm)' },
  { key: 'macos', label: 'macOS' },
];


const WebAppAgentDownload = ({ className = "" }) => {
  const { t } = useTranslation();
  const [isDownloading, setIsDownloading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleDownload = async (osType) => {
    setIsDownloading(true);
    setIsOpen(false);

    try {
      const { data, error } = await downloadAgentAPI(osType);

      if (error) {
        if (error.error === "AGENT_NOT_AVAILABLE") {
          toast.info(t("webAppAgent.agentComingSoon"));
        } else {
          toast.error(t("webAppAgent.downloadFailed"));
        }
        return;
      }

      const blob = new Blob([data], { type: 'application/zip' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `XecureAccess-${osType}.zip`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Download failed:', error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div
      ref={dropdownRef}
      className={`web-app-agent-download ff-pam fw-400 fs-14px position-relative d-flex align-items-center justify-content-center ${className}`}
    >
      {isDownloading ? (
        <button className="os-installer-btn downloading" disabled>
          <span>{t("webAppAgent.downloading")}</span>
        </button>
      ) : (
        <>
          <button
            className="os-installer-btn fw-500"
            onClick={() => setIsOpen(!isOpen)}
            title={t("webAppAgent.downloadXecureAccess")}
          >
            <FiDownload size={18} className="icon-left" />
            <span style={{ flex: 1, textAlign: 'left' }}>{t("webAppAgent.downloadXecureAccess")}</span>
            <FiChevronDown size={18} className="icon-right" />
          </button>

          {isOpen && (
            <div className="os-dropdown">
              {OS_LIST.map((os) => (
                <button
                  key={os.key}
                  className="dropdown-item"
                  onClick={() => handleDownload(os.key)}
                >
                  {os.label}
                </button>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default WebAppAgentDownload;
